import { render, staticRenderFns } from "./packAndpallet.vue?vue&type=template&id=4021e592&"
import script from "./packAndpallet.vue?vue&type=script&lang=js&"
export * from "./packAndpallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports